import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { LOCALSTORAGE_KEY_CHAT } from "utils/constants";

export const aiMessagesAtom = atomWithStorage(LOCALSTORAGE_KEY_CHAT, null);

export const randomnessValAtom = atom<number>(0.3);
export const uniquenessValAtom = atom<number>(0);
export const wordValAtom = atom<number>(200);
